
import React from "react";
import { Button } from "@/components/ui/button";
import { Upload } from "lucide-react";

interface EmptyStateProps {
  onUpload: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ onUpload }) => {
  return (
    <div className="text-center py-10 border border-dashed rounded-lg">
      <Upload className="mx-auto h-10 w-10 text-gray-400 mb-2" />
      <h3 className="text-lg font-medium">No videos uploaded</h3>
      <p className="text-gray-500 mb-4">Upload videos to analyze player and ball movement</p>
      <Button onClick={onUpload}>
        Upload Your First Video
      </Button>
    </div>
  );
};

export default EmptyState;
